import React, { Component } from 'react'
import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal,Checkbox,Popup } from 'semantic-ui-react'
import Success from '../../assets/images/success.png'
import Error from '../../assets/images/error.png'
import Warning from '../../assets/images/warning.png'
import Info from '../../assets/images/info.png'
import SpinLoader from '../../assets/images/spinner.gif'

export default function Alertmessage(props) {

    //spinner
    //{intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}}

    //success
    //{intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Record successfully deleted."}}

    //error
    //{intent:'alert',settings:{centered:false,icon:'error',title:'Delete Failed',html:"Record not successfully deleted."}}

    //warning
    //{intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}}

    //confirm delete
    //{intent:'delete',settings:{id:id,centered:false,icon:'warning',title:'Delete Confirmation!',html:'This process is not ireversible. Once you continue the process, the record will be deleted on the database.',footer:'none'}}

    function Close(){props.close(false);}
    function ContinueDelete(data){
      props.delete(data);
    }
    function ContinueProccess(data){
      props.confirm(data);
    }

    return (
     <React.Fragment>

         {(props.data.intent=='spinner'||
         props.data.intent=='delete'||
         props.data.intent=='confirm'||
         props.data.intent=='alert')&&<Modal basic={props.data.intent=='spinner'} centered={props.data.settings.centered} open={true} size='mini'>
          <Modal.Content className="modal_alert" scrolling>

            {props.data.intent!='spinner'&&<div>
              {props.data.settings.icon=='success'&&<img src={Success}/>}
              {props.data.settings.icon=='error'&&<img src={Error}/>}
              {props.data.settings.icon=='warning'&&<img src={Warning}/>}
              {props.data.settings.icon=='info'&&<img src={Info}/>}
            </div>}

            {props.data.intent=='spinner'&&<svg className="alertspinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
               <circle className="path" fill="none" strokeWidth="3" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
            </svg>}

            <h1>{props.data.settings.title}</h1>
            <p>{props.data.settings.html}</p>

          </Modal.Content>

          {props.data.intent=='delete'&&<Modal.Actions className="modal_footer">
            <Button className="red" icon='close' content='Cancel' onClick={()=>Close()}/>
            <Button className="primarylight" icon='check circle' content='Yes, Confirm' onClick={()=>ContinueDelete({delete:true,id:props.data.settings.id,types:props.data.settings.types})}/>
          </Modal.Actions>}

          {props.data.intent=='confirm'&&<Modal.Actions className="modal_footer">
            <Button className="red" icon='close' content='Cancel' onClick={()=>Close()}/>
            <Button className="primarylight" icon='check circle' content='Yes, Confirm' onClick={()=>ContinueProccess({confirm:true,id:props.data.settings.id})}/>
          </Modal.Actions>}

          {props.data.intent=='alert'&&props.data.settings.footer=='yes'&&<Modal.Actions className="modal_footer">
            <Button className="primarylight" icon='check circle' content='Ok. Close' onClick={()=>Close(false)}/>
          </Modal.Actions>}

         </Modal>}


         /*{props.data.intent=='inline_spinner'&&<div className={props.data.settings.top==1?'app-inline-spinner top':'app-inline-spinner'}>
          <div className="app-inline-spinner-container">
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="45"/>
              </svg>
             <h1>{props.data.settings.title}</h1>
             <p>{props.data.settings.html}</p>
           </div>
         </div>}*/
         {props.data.intent=='inline_spinner'&&<div className={props.data.settings.top==1?'app-inline-spinner top':'app-inline-spinner'}>
          <div className="app-inline-spinner-container">
             <img src={SpinLoader}/>
             <h1>{props.data.settings.title}</h1>
             <p>{props.data.settings.html}</p>
           </div>
         </div>}



         /*{props.data.intent=='icon_spinner'&&<div className='app-icon-spinner'>
          <div className="app-inline-spinner-container">
            <svg class="spinloader" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>
           </div>
         </div>}*/

         {props.data.intent=='icon_spinner'&&<div className='app-icon-spinner'>
          <div className="app-inline-spinner-container">
            <img src={SpinLoader}/>
           </div>
         </div>}


      </React.Fragment>
    );

}
